import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AutenticacaoService } from '@app/services/autenticacao.service';

@Injectable({
  providedIn: 'root'
})
export class VerificacaoNovaSenhaGuard implements CanActivate {

  constructor(
    private autenticacaoService: AutenticacaoService,
    private router: Router
  ) { }

  canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

    const query = activatedRouteSnapshot.queryParams;
    const fazerRedacao = query ? query.fazerRedacao || '0' : '0';

    if (fazerRedacao === '1') {
      return true;
    }

    if (!this.autenticacaoService.getValorUsuarioAtualCandidato.novaSenha) {
      return true;
    }

    if (routerStateSnapshot.url !== '/alteracao-senha') {
      this.router.navigate(['/alteracao-senha'], { queryParams: { urlRetorno: routerStateSnapshot.url } });
    } else {
      this.router.navigate(['/alteracao-senha']);
    }
    return false;

  }

}
